// Object.values, which IE 11 lacks
export default function objectValues(object) {
  var keys = Object.keys(object);
  var result = [];
  for (var i = 0; i < keys.length; i++) result.push(object[keys[i]]);
  return result;
}